import {makeReducer, match} from 'web-app/util/redux';
import {type PaymentsSourceType} from 'web-app/util/graphql/api-types';
import {type ModalState, open, close} from 'web-app/react/modals-container/types';

import * as Actions from './actions';
import {type FlexiblePayments} from './types';

export type PayNowModalState = ModalState<{
    readonly amount: number;
    readonly paymentPayload: string;
    readonly institutionId: string;
    readonly billPayerId: string;
    readonly enabledPaymentsSourceTypes: PaymentsSourceType[];
    readonly isSubmitting: boolean;
    readonly flexiblePayments: FlexiblePayments | null;
    readonly shouldMakeFeeCalculation: boolean;
    readonly isInternal?: boolean;
    readonly onSuccess?: () => void;
}>;

export default makeReducer<PayNowModalState>(
    [
        match(Actions.show, (state, {payload}) => {
            return open({
                amount: payload.amount,
                paymentPayload: payload.paymentPayload,
                institutionId: payload.institutionId,
                billPayerId: payload.billPayerId,
                enabledPaymentsSourceTypes: payload.enabledPaymentsSourceTypes,
                flexiblePayments: payload.flexiblePayments,
                shouldMakeFeeCalculation: payload.shouldMakeFeeCalculation,
                isSubmitting: false,
            });
        }),
        match(Actions.hide, () => {
            return close();
        }),
        match(Actions.startSubmit, state => {
            return {
                ...state,
                isSubmitting: true,
            };
        }),
        match(Actions.stopSubmit, state => {
            return {
                ...state,
                isSubmitting: false,
            };
        }),
    ],
    close(),
);
